import React, { Component } from "react";
import { NavLink } from "react-router-dom";
export default class Footer extends Component {
	render() {
		return (
			<div className="footer">
				<div className="medium-padding black-background">
					<div className="row">
						<div className="small-12 medium-4">
							<img alt="" className="quarter-width" src="images/logo-light.png" style={{'maxWidth':'80px'}} />
							<p className="white" style={{'marginTop':'0px'}}>Crafting Impressions That Last</p>
							<p className="white subheading">
								&copy; Alpine Design LLC<br />
								All Rights Reserved
							</p>
						</div>
						<div className="small-12 medium-5 row">
							<p className="white full-width center-position" style={{'margin':'auto'}}><span className="subheading">We like to work with people who are passionate about leading their industry. Learn how we can work together. </span><NavLink exact to="/contact" className="white" style={{'textDecoration':'none'}}><b>Get Started Today.</b></NavLink></p>
						</div>
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/footer.js